import { render, staticRenderFns } from "./SolicitudesProducto.vue?vue&type=template&id=fcf7c040&scoped=true&"
import script from "./SolicitudesProducto.vue?vue&type=script&lang=js&"
export * from "./SolicitudesProducto.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudesProducto.vue?vue&type=style&index=0&id=fcf7c040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf7c040",
  null
  
)

export default component.exports